export const DELETE_DATASET_START = "DELETE_DATASET_START";
export const DELETE_DATASET_SUCCESS = "DELETE_DATASET_SUCCESS";
export const DELETE_DATASET_FAIL = "DELETE_DATASET_FAIL";


export const CHANGE_DATASET = "CHANGE_DATASET";
